var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDplinkArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1795 9.04257L6.52277 13.1859C6.08742 13.5732 6.05533 14.2326 6.45103 14.6587C6.84674 15.0848 7.52041 15.1162 7.95576 14.7289L14.6512 8.77151C15.1163 8.35787 15.1163 7.64212 14.6512 7.22849L7.95576 1.27112C7.52041 0.883805 6.84676 0.915217 6.45103 1.34133C6.05533 1.76744 6.08742 2.42655 6.52277 2.81411L11.1795 6.95743H2.06539C1.47713 6.95743 1 7.42419 1 7.99997C1 8.57575 1.47711 9.04275 2.06539 9.04275L11.1795 9.04257Z",
    fill: "#0C68F4",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDplinkArrow);
export default __webpack_public_path__ + "static/media/dplink-arrow.f869a360e4b97691efe7520a1f93d19e.svg";
export { ForwardRef as ReactComponent };